import React from 'react';
import { Typography } from '@mui/material';

export default function SelectTargetTypeHeader() {
  return (
    <div className='header-container mb-5'>
      <Typography variant='h3' component='h3'>
        Select a Target Type
      </Typography>

      <Typography component='span' className='subheader'>
        Create a new Target to move your data
      </Typography>
    </div>
  );
}
